export class AdditionalPointDto {
    name?:string;
    zone?:string;
    destinationType?:string;
    destinationTypeValue?:string;
    address?:string;
    street:string;
    locationName:string;
    locationOid:number;
    geoLocation:any={};
    meetingPhone:string;
    shouldCall?:boolean=false;
    pointOfSaleOid?:number;
    surcharge?:string;

    pickupIndications?:{
        meetingType?:string,
        additionalInstructions?:string,
        phoneRequired?:string,
        phoneOptional?:string,
        miamiAirportPositions?:Array<string>,
        orlandoAirportPositions?: [{
            id?:number,
            terminal?:string,
            stop?:number,
            range?:{minValue:number,maxValue:number}}],
        cancunAirportPositions?: {
            hasCounter?:boolean,
            counters?:Array<{
                counter:string,
                position:string}>}
    };

    constructor() {
    }
}



// WEBPACK FOOTER //
// ./public/upgrade/feature/additionalPoint/additional-point-dto.ts